export class AuthorizeRedirectUrlGetRequest {
  transitionTo?: string

  constructor(transitionTo?: string) {
    this.transitionTo = transitionTo
  }
}

/**
 * 認可コード発行エンドポイント取得用レスポンス
 * @param usingAzure AzureADB2CのAPIと接続するかどうか。mock化せずに接続する場合はtrue
 * @param redirectTo CIAMログイン画面へのリダイレクトURL ⇒ 本番時のみ使用。mock利用時はundefined
 * @param encryptedTransitionTo 暗号化したsmooth-eログイン完了後の遷移先種別 ⇒ mock利用時のみ使用。本番時はundefined
 * @param stateKey state照合用のキー ⇒ 本番時のみ使用。mock利用時はundefined
 */
export class AuthorizeRedirectUrlGetResponse {
  usingAzure: boolean
  redirectTo?: string
  encryptedTransitionTo?: string
  stateKey?: string

  constructor(usingAzure: boolean, redirectTo?: string, encryptedTransitionTo?: string, stateKey?: string) {
    this.usingAzure = usingAzure
    this.redirectTo = redirectTo
    this.encryptedTransitionTo = encryptedTransitionTo
    this.stateKey = stateKey
  }

  static withRedirectTo(usingAzure: boolean, redirectTo: string): AuthorizeRedirectUrlGetResponse {
    return new AuthorizeRedirectUrlGetResponse(usingAzure, redirectTo, undefined, undefined)
  }

  static withEncryptedTransitionTo(usingAzure: boolean, encryptedTransitionTo: string): AuthorizeRedirectUrlGetResponse {
    return new AuthorizeRedirectUrlGetResponse(usingAzure, undefined, encryptedTransitionTo, undefined)
  }
}
